import { useEffect, useRef } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';

export const useAsyncOktaAuthCheck = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const pendingLogin = useRef(false);

  useEffect(() => {
    const handleLogin = () => {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      );

      if (!pendingLogin.current) {
        pendingLogin.current = true;
        oktaAuth.setOriginalUri(originalUri);
        oktaAuth.signInWithRedirect();
      }
    };

    const isCallbackRoute = window.location.pathname === '/login/callback';

    if (authState && !isCallbackRoute) {
      if (authState.isAuthenticated) {
        pendingLogin.current = false;
      } else if (!authState.isPending) {
        handleLogin();
      }
    }
  }, [authState, oktaAuth]);

  if (!authState || !authState.isAuthenticated) {
    return null;
  }

  return authState.isAuthenticated;
};
